const OK_MAPPING_STATUSES = new Set(["auto", "manual", "auto_warn", "manual_warn"]);
const OK_IMPORT_STATE = "COMPLETED";

export const VENDOR_PROBLEMATIC_FILTER_STORAGE_KEY = "cm-vendor-problematic-filter";

export const normalizeMappingStatus = (value) => String(value || "").trim().toLowerCase();

export const normalizeImportState = (value) => String(value || "").trim().toUpperCase();

export const isProblematicVendor = (row) => {
  if (!row) {
    return false;
  }

  const mappingStatus = normalizeMappingStatus(row.mapping_status);
  const importState = normalizeImportState(row.last_run_state);

  const mappingOk = OK_MAPPING_STATUSES.has(mappingStatus);
  const importOk = importState === OK_IMPORT_STATE;

  return !mappingOk || !importOk;
};

export const loadPersistedProblematicFilter = () => {
  try {
    return window.sessionStorage.getItem(VENDOR_PROBLEMATIC_FILTER_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const persistProblematicFilter = (enabled) => {
  try {
    if (enabled) {
      window.sessionStorage.setItem(VENDOR_PROBLEMATIC_FILTER_STORAGE_KEY, "1");
    } else {
      window.sessionStorage.removeItem(VENDOR_PROBLEMATIC_FILTER_STORAGE_KEY);
    }
  } catch {
    // ignore storage failures
  }
};
